import { render } from "./InterventionDetailPage.vue?vue&type=template&id=5f66be3c&scoped=true&ts=true"
import script from "./InterventionDetailPage.vue?vue&type=script&lang=ts"
export * from "./InterventionDetailPage.vue?vue&type=script&lang=ts"

import "./InterventionDetailPage.vue?vue&type=style&index=0&id=5f66be3c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f66be3c"]])

export default __exports__